import { manualData } from "../data/generated";
import type { GameState, ManualSection } from "../types";

interface ManualScreenProps {
  run: GameState;
  onBack: () => void;
}

function getManual(run: GameState) {
  const ids = [...run.manualMutationIds];
  if (run.currentMail?.manualMutationId) ids.push(run.currentMail.manualMutationId);
  let version = manualData.version;
  let updatedAt = manualData.updatedAt;
  let author = manualData.author;
  let sections: ManualSection[] = manualData.sections.map((section) => ({ ...section, paragraphs: [...section.paragraphs] }));

  for (const id of ids) {
    const mutation = manualData.mutations[id];
    if (!mutation) continue;
    version = mutation.version ?? version;
    updatedAt = mutation.updatedAt ?? updatedAt;
    author = mutation.author ?? author;
    if (mutation.replaceParagraph) {
      sections = sections.map((section) => section.id === "rules"
        ? { ...section, paragraphs: [mutation.replaceParagraph!, ...section.paragraphs.slice(1)] }
        : section);
    }
    if (mutation.appendParagraph) {
      sections = sections.map((section) => section.id === "prohibited"
        ? { ...section, paragraphs: [...section.paragraphs, mutation.appendParagraph!] }
        : section);
    }
  }
  if (run.loopCount >= 3 && !ids.includes("loop_notice")) {
    sections = sections.map((section) => section.id === "prohibited"
      ? { ...section, paragraphs: [...section.paragraphs, `この項目を読むのは今回で${run.loopCount}回目です。`] }
      : section);
  }
  return { version, updatedAt, author, sections };
}

export function ManualScreen({ run, onBack }: ManualScreenProps) {
  const manual = getManual(run);
  return (
    <main className="document-screen app-surface">
      <header className="document-header">
        <div><div className="document-kicker">NIGHT WATCH PROCEDURE</div><h1>{manualData.title}</h1></div>
        <button type="button" onClick={onBack}>ポータルへ戻る</button>
      </header>
      <article className="manual-paper">
        <div className="manual-meta">
          <span>文書番号: NW-MAIL-032</span><span>版: {manual.version}</span><span>更新: {manual.updatedAt}</span><span>作成: {manual.author}</span>
        </div>
        {manual.sections.map((section) => (
          <section key={section.id}>
            <h2>{section.heading}</h2>
            {section.paragraphs.map((paragraph, index) => <p key={`${section.id}-${index}`}>{paragraph}</p>)}
          </section>
        ))}
        <div className="manual-stamp">社外秘</div>
      </article>
    </main>
  );
}
